<!-- Identity and Demographics — layout/validation aligned with manage-profile-form -->
<div class="row ml-0 mr-0 lookup-user-personal-wrap">
  <div class="panel-blue">
    <div
      class="header"
      (click)="toggleIdentityPanel()"
      tabindex="0"
      role="button"
      [attr.aria-expanded]="showIdentityPanel"
      aria-controls="lookupIdentityPanel"
      aria-label="Identity and Demographics section, toggle to expand or collapse">
      <span class="panel-title">Identity and Demographics</span>
      <button
        type="button"
        class="toggle-panel"
        *ngIf="showIdentityPanel"
        (click)="toggleIdentityPanel(); $event.stopPropagation()"
        aria-label="Collapse">
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="toggle-panel"
        *ngIf="!showIdentityPanel"
        (click)="toggleIdentityPanel(); $event.stopPropagation()"
        aria-label="Expand">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
    </div>
    <div class="panel-body" id="lookupIdentityPanel" *ngIf="showIdentityPanel">
      <form [formGroup]="personalForm" novalidate>
        <div class="row ml-0 mr-0">
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_dob">Date of Birth<span class="requiredfield text-danger">*</span></label>
            <div class="input-group ssn-input-group">
              <input
                type="text"
                id="lookup_dob"
                class="form-control formField date-uppercase mt-1"
                formControlName="dateOfBirth"
                [placeholder]="placeholderMessage['P0007'] || 'Select Date of Birth'"
                maxlength="10"
                (input)="formatDateInput($event)"
                [attr.aria-invalid]="personalForm.get('dateOfBirth')?.touched && personalForm.get('dateOfBirth')?.invalid ? 'true' : null"
                [attr.aria-describedby]="personalForm.get('dateOfBirth')?.touched && personalForm.get('dateOfBirth')?.invalid ? 'lookup_dob_error' : null"
                [ngClass]="{
                  'is-invalid': personalForm.get('dateOfBirth')?.invalid && personalForm.get('dateOfBirth')?.touched,
                  'has-value': !!personalForm.get('dateOfBirth')?.value
                }" />
              <span class="ssn-eye mt-1">
                <button type="button" id="btn_lookup_dob_open_calendar" class="btn p-0 eye" tabindex="7"
                  (click)="openDatePicker($event)" (keypress)="openDatePicker($event)" title="Open Calendar"
                  aria-label="Open date picker">
                  <span class="material-symbols-outlined f-20 cal">calendar_month</span>
                </button>
              </span>
            </div>
            <div id="lookup_dob_error" *ngIf="personalForm.get('dateOfBirth')?.touched && personalForm.get('dateOfBirth')?.errors as dobErrors">
              <div *ngIf="dobErrors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0009'] || 'Date of Birth is required.' }}</div>
              <div *ngIf="dobErrors['ageInvalid']" class="text-danger mt-1 err-font">{{ errorMessage['M0010'] || 'Invalid date or age.' }}</div>
              <div *ngIf="dobErrors['futureDate']" class="text-danger mt-1 err-font">{{ errorMessage['M0010'] || 'Invalid date or age.' }}</div>
            </div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_gender">Gender<span class="requiredfield text-danger">*</span></label>
            <div class="dropdown-clear-wrapper mt-1 lookup-identity-select-wrap">
              <select
                id="lookup_gender"
                class="formField form-control"
                formControlName="gender"
                (change)="blurSelect($event)"
                [attr.aria-invalid]="personalForm.get('gender')?.touched && personalForm.get('gender')?.invalid ? 'true' : null"
                [attr.aria-describedby]="personalForm.get('gender')?.touched && personalForm.get('gender')?.invalid ? 'lookup_gender_error' : null"
                [style.color]="personalForm.get('gender')?.value == null ? '#757575' : null"
                [ngClass]="{
                  'is-invalid': personalForm.get('gender')?.touched && personalForm.get('gender')?.invalid,
                  'empty-select': personalForm.get('gender')?.value == null
                }"
                [matTooltip]="getSelectLabel(personalForm.get('gender')?.value, genderList)"
                matTooltipPosition="above"
                matTooltipClass="custom-tooltip">
                <option hidden disabled [ngValue]="null" style="color: #757575 !important;">
                  {{ placeholderMessage['P0004'] || 'Select Gender' }}
                </option>
                <option *ngFor="let list of genderList" [value]="list.key">{{ list.value }}</option>
              </select>
            </div>
            <div
              id="lookup_gender_error"
              *ngIf="personalForm.get('gender')?.touched && personalForm.get('gender')?.errors?.['required']"
              class="text-danger mt-1 err-font">
              {{ errorMessage['M0006'] || 'Required' }}
            </div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_race">Race<span class="requiredfield text-danger">*</span></label>
            <div class="dropdown-clear-wrapper mt-1 lookup-identity-select-wrap">
              <select
                id="lookup_race"
                class="formField form-control"
                formControlName="race"
                (change)="blurSelect($event)"
                [attr.aria-invalid]="personalForm.get('race')?.touched && personalForm.get('race')?.invalid ? 'true' : null"
                [attr.aria-describedby]="personalForm.get('race')?.touched && personalForm.get('race')?.invalid ? 'lookup_race_error' : null"
                [style.color]="personalForm.get('race')?.value == null ? '#757575' : null"
                [ngClass]="{
                  'is-invalid': personalForm.get('race')?.touched && personalForm.get('race')?.invalid,
                  'empty-select': personalForm.get('race')?.value == null
                }"
                [matTooltip]="getSelectLabel(personalForm.get('race')?.value, raceList)"
                matTooltipPosition="above"
                matTooltipClass="custom-tooltip">
                <option hidden disabled [ngValue]="null" style="color: #757575 !important;">
                  {{ placeholderMessage['P0005'] || 'Select Race' }}
                </option>
                <option *ngFor="let list of raceList" [value]="list.key">{{ list.value }}</option>
              </select>
            </div>
            <div
              id="lookup_race_error"
              *ngIf="personalForm.get('race')?.touched && personalForm.get('race')?.errors?.['required']"
              class="text-danger mt-1 err-font">
              {{ errorMessage['M0007'] || 'Required' }}
            </div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_ethnicity">Ethnicity<span class="requiredfield text-danger">*</span></label>
            <div class="dropdown-clear-wrapper mt-1 lookup-identity-select-wrap">
              <select
                id="lookup_ethnicity"
                class="formField form-control"
                formControlName="ethnicity"
                (change)="blurSelect($event)"
                [attr.aria-invalid]="personalForm.get('ethnicity')?.touched && personalForm.get('ethnicity')?.invalid ? 'true' : null"
                [attr.aria-describedby]="personalForm.get('ethnicity')?.touched && personalForm.get('ethnicity')?.invalid ? 'lookup_ethnicity_error' : null"
                [style.color]="personalForm.get('ethnicity')?.value == null ? '#757575' : null"
                [ngClass]="{
                  'is-invalid': personalForm.get('ethnicity')?.touched && personalForm.get('ethnicity')?.invalid,
                  'empty-select': personalForm.get('ethnicity')?.value == null
                }"
                [matTooltip]="getSelectLabel(personalForm.get('ethnicity')?.value, ethinicityList)"
                matTooltipPosition="above"
                matTooltipClass="custom-tooltip">
                <option hidden disabled [ngValue]="null" style="color: #757575 !important;">
                  {{ placeholderMessage['P0006'] || 'Select Ethnicity' }}
                </option>
                <option *ngFor="let list of ethinicityList" [value]="list.key">{{ list.value }}</option>
              </select>
            </div>
            <div
              id="lookup_ethnicity_error"
              *ngIf="personalForm.get('ethnicity')?.touched && personalForm.get('ethnicity')?.errors?.['required']"
              class="text-danger mt-1 err-font">
              {{ errorMessage['M0008'] || 'Required' }}
            </div>
          </div>
        </div>
        <div class="row ml-0 mr-0 mt-2">
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_itin" class="d-block text-truncate" title="Individual Taxpayer Identification Number">Individual Taxpayer Identification Number</label>
            <div class="input-group ssn-input-group">
              <input
                type="text"
                id="lookup_itin"
                class="form-control ssn-input formField"
                formControlName="itin"
                ssnMask
                toggleMask
                [maskType]="'ITIN'"
                (maskBlur)="onSsnItinMaskDisplayBlur($event)"
                (input)="onPersonalSsnItinInput('itin')"
                (focus)="isITINFocused = true"
                (blur)="isITINFocused = false"
                maxlength="11"
                autocomplete="off"
                [placeholder]="placeholderMessage['P0118'] || 'Enter ITIN'"
                [attr.aria-invalid]="
                  (personalForm.get('itin')?.touched && personalForm.get('itin')?.errors?.['itinInvalid']) || itinExists
                    ? 'true'
                    : null
                "
                [attr.aria-describedby]="
                  (itinExists && !isITINFocused) ||
                  (personalForm.get('itin')?.touched &&
                    personalForm.get('itin')?.errors?.['itinInvalid'] &&
                    !itinExists)
                    ? 'itin-error'
                    : null
                "
                [ngClass]="{
                  'is-invalid':
                    (personalForm.get('itin')?.touched && personalForm.get('itin')?.errors?.['itinInvalid']) ||
                    (itinExists && !isITINFocused)
                }" />
            </div>
            <div
              *ngIf="
                (itinExists && !isITINFocused) ||
                (personalForm.get('itin')?.touched &&
                  personalForm.get('itin')?.errors?.['itinInvalid'] &&
                  !itinExists)
              "
              id="itin-error">
              <div *ngIf="itinExists && !isITINFocused" class="text-danger mt-1 err-font">
                {{ errorMessage['M0084'] || 'This ITIN is already in use.' }}
              </div>
              <div
                *ngIf="
                  personalForm.get('itin')?.touched &&
                  personalForm.get('itin')?.errors?.['itinInvalid'] &&
                  !itinExists
                "
                class="text-danger mt-1 err-font">
                {{ errorMessage['M0040'] || 'Please enter a valid ITIN.' }}
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_ssn">Social Security Number<span *ngIf="ssnRequired" class="requiredfield text-danger">*</span></label>
            <div class="input-group ssn-input-group">
              <input
                type="text"
                id="lookup_ssn"
                class="form-control ssn-input formField"
                formControlName="ssn"
                numbersOnly
                ssnMask
                toggleMask
                [maskType]="'SSN'"
                (maskBlur)="onSsnItinMaskDisplayBlur($event)"
                (input)="onPersonalSsnItinInput('ssn')"
                (focus)="isSSNFocused = true"
                (blur)="isSSNFocused = false"
                maxlength="11"
                autocomplete="off"
                [placeholder]="placeholderMessage['P0028'] || 'Enter SSN'"
                [attr.aria-required]="ssnRequired ? 'true' : null"
                [attr.aria-invalid]="(personalForm.get('ssn')?.touched && personalForm.get('ssn')?.invalid) || ssnExists ? 'true' : null"
                [attr.aria-describedby]="(personalForm.get('ssn')?.touched && personalForm.get('ssn')?.invalid) || ssnExists ? 'ssn-error' : null"
                [ngClass]="{
                  'is-invalid': (personalForm.get('ssn')?.touched && personalForm.get('ssn')?.invalid) || (ssnExists && !isSSNFocused)
                }" />
            </div>
            <div *ngIf="personalForm.get('ssn')?.touched && personalForm.get('ssn')?.errors as errors">
              <div id="ssn-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">
                {{ errorMessage['M0011'] || 'Please enter your SSN.' }}
              </div>
              <div id="ssn-error" *ngIf="!errors['required'] && errors['pattern']" class="text-danger mt-1 err-font">
                {{ errorMessage['M0012'] || 'Please enter a valid SSN.' }}
              </div>
              <div id="ssn-error" *ngIf="!errors['required'] && !errors['pattern'] && errors['ssnInvalid']" class="text-danger mt-1 err-font">
                {{ errorMessage['M0013'] || 'Invalid SSN.' }}
              </div>
            </div>
            <div *ngIf="ssnExists && !isSSNFocused" id="ssn-error" class="text-danger mt-1 err-font">
              {{ errorMessage['M0083'] || 'This SSN is already in use.' }}
            </div>
          </div>
        </div>
        <div class="row mb-3 fullWidth ml-0 mr-0 mt-3">
          <div class="col text-right border-top pt-3 pr-0 manage-action">
            <button
              type="button"
              id="btn_lookup_personal_reset"
              class="btn btn-outline-secondary mr-2"
              [disabled]="personalForm.pristine"
              (click)="onPersonalReset()">
              Reset
            </button>
            <button
              type="button"
              id="btn_lookup_personal_update"
              class="btn btn-primary"
              [disabled]="personalForm.invalid || personalForm.pristine || ssnExists || itinExists"
              (click)="onPersonalUpdate()">
              Update
            </button>
          </div>
        </div>
      </form>

      <h6 class="document-grid-title">Supporting Documents</h6>

      <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap gap-2 py-2" (click)="$event.stopPropagation()">
          <div class="lookup-personal-grid-actions-wrap d-flex align-items-center">
            <app-grid-actions
              [actions]="lookupPersonalExportColumnChooserActions"
              [showColumnChooser]="showIdentityPhotoSupportingDocumentsColumnChooser"
            [visibleColumns]="identityPhotoSupportingDocumentsColumnVisibility"
            (exportClick)="onIdentityPhotoSupportingDocumentsExportExcel()"
            (columnChooserToggle)="toggleIdentityPhotoSupportingDocumentsColumnChooser()"
            (columnToggle)="onIdentityPhotoSupportingDocumentsColumnToggle($event)"
            (columnChooserClose)="closeIdentityPhotoSupportingDocumentsColumnChooser()">
          </app-grid-actions>
        </div>
        <button type="button" class="btn btn-primary btn-sm" (click)="onIdentityPhotoSupportingDocumentsUpload()">
          <i class="fa fa-upload mr-1" aria-hidden="true"></i> Upload
        </button>
      </div>
      </div>

      <div class="tab-content border rounded my-applications-container p-2 mb-2" style="margin-left:0;margin-right:0;">
        <app-data-grid
          #identityPhotoSupportingDocumentsGrid
          [config]="identityPhotoSupportingDocumentsGridConfig"
          [activeTab]="'personal'"
          [statusDataField]="'document_status'"
          [submittedStatusValues]="['Uploaded', 'Verified', 'uploaded', 'verified']"
          [wordWrapEnabled]="false">
          <ng-template #actionsTemplate let-data let-rowIndex="index">
            <div class="action-buttons-container" [attr.data-row]="rowIndex" role="group" [attr.aria-label]="'Actions for ' + (data.file_name ?? 'document')">
              <span class="action-span-wrapper">
                <button type="button" class="action-icon-button"
                  [disabled]="!supportingDocumentHasValidId(data)"
                  matTooltip="View"
                  matTooltipPosition="above"
                  (click)="viewSupportingDocument(data); $event.stopPropagation()">
                  <span class="material-symbols-outlined">visibility</span>
                </button>
              </span>
              <span class="action-span-wrapper ml-1">
                <button type="button" class="action-icon-button"
                  [disabled]="!supportingDocumentHasValidId(data)"
                  matTooltip="Download"
                  matTooltipPosition="above"
                  (click)="downloadSupportingDocument(data); $event.stopPropagation()">
                  <span class="material-symbols-outlined">download</span>
                </button>
              </span>
            </div>
          </ng-template>
        </app-data-grid>
      </div>
    </div>
  </div>
</div>

<!-- Contact panel -->
<div class="row ml-0 mr-0 lookup-user-personal-wrap">
  <div class="panel-blue">
    <div
      class="header"
      (click)="toggleContactPanel()"
      tabindex="0"
      role="button"
      [attr.aria-expanded]="showContactPanel"
      aria-controls="lookupContactPanel"
      aria-label="Contact section, toggle to expand or collapse">
      <span class="panel-title">Contact</span>
      <button type="button" class="toggle-panel" *ngIf="showContactPanel" (click)="toggleContactPanel(); $event.stopPropagation()" aria-label="Collapse">
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </button>
      <button type="button" class="toggle-panel" *ngIf="!showContactPanel" (click)="toggleContactPanel(); $event.stopPropagation()" aria-label="Expand">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
    </div>
    <div class="panel-body" id="lookupContactPanel" *ngIf="showContactPanel">
      <form [formGroup]="contactForm" novalidate>
        <div class="row ml-0 mr-0">
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_contact_email">Email<span class="requiredfield text-danger">*</span></label>
            <input type="email" id="lookup_contact_email" class="formField" formControlName="email" [placeholder]="placeholderMessage['P0009'] || 'Enter'"
              maxlength="255"
              [ngClass]="{ 'is-invalid': (contactForm.get('email')?.invalid && contactForm.get('email')?.touched) || emailExists }" />
            <div *ngIf="contactForm.get('email')?.touched && contactForm.get('email')?.errors?.['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0014'] || 'Please enter a valid email address.' }}</div>
            <div *ngIf="contactForm.get('email')?.touched && !contactForm.get('email')?.errors?.['required'] && contactForm.get('email')?.errors?.['pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0015'] || 'Please enter a valid email format.' }}</div>
            <div *ngIf="emailExists" class="text-danger mt-1 err-font" role="alert">{{ errorMessage['M0085'] || 'The email entered is already on file.' }}</div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_contact_recovery">Recovery Email</label>
            <input type="email" id="lookup_contact_recovery" class="formField" formControlName="recoveryEmail" [placeholder]="placeholderMessage['P0009'] || 'Enter'"
              maxlength="255"
              [ngClass]="{ 'is-invalid': (contactForm.get('recoveryEmail')?.invalid && contactForm.get('recoveryEmail')?.touched) || recoveryEmailExists || contactRecoveryMatchesPrimary() }" />
            <div *ngIf="contactForm.get('recoveryEmail')?.touched && contactForm.get('recoveryEmail')?.errors?.['pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0015'] || 'Please enter a valid email format.' }}</div>
            <div *ngIf="recoveryEmailExists" class="text-danger mt-1 err-font" role="alert">{{ errorMessage['M0086'] || 'The recovery email entered is already on file.' }}</div>
            <div *ngIf="contactRecoveryMatchesPrimary()" class="text-danger mt-1 err-font" role="alert">{{ errorMessage['M0088'] || 'Recovery email must be different from the primary email address.' }}</div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_contact_phone">Phone Number<span class="requiredfield text-danger">*</span></label>
            <div
              class="lookup-contact-phone-field"
              [class.is-invalid]="(contactForm.get('phone')?.invalid && contactForm.get('phone')?.touched) || phoneExists">
              <span class="lookup-contact-phone-prefix" aria-hidden="true">+1</span>
              <input
                type="tel"
                id="lookup_contact_phone"
                class="formField lookup-contact-phone-input"
                formControlName="phone"
                [placeholder]="placeholderMessage['P0010'] || '(555) 555-5555'"
                maxlength="14"
                aria-label="Phone number" />
            </div>
            <div *ngIf="contactForm.get('phone')?.touched && contactForm.get('phone')?.errors?.['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0016'] || 'Please enter phone number.' }}</div>
            <div *ngIf="contactForm.get('phone')?.touched && !contactForm.get('phone')?.errors?.['required'] && contactForm.get('phone')?.errors?.['phoneInvalid']" class="text-danger mt-1 err-font">{{ errorMessage['M0017'] || 'Please enter a valid phone number.' }}</div>
            <div *ngIf="phoneExists" class="text-danger mt-1 err-font" role="alert">{{ errorMessage['M0087'] || 'The phone number entered is already on file.' }}</div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_contact_alt">Alternate Phone</label>
            <div
              class="lookup-contact-alt-phone-field"
              [class.is-invalid]="(contactForm.get('alternatePhone')?.invalid && contactForm.get('alternatePhone')?.touched) || alternatePhoneExists">
              <input
                type="tel"
                id="lookup_contact_alt"
                class="formField lookup-contact-alt-phone-input lookup-contact-alt-phone-full"
                formControlName="alternatePhone"
                [placeholder]="placeholderMessage['P0010'] || '+1 (555) 555-5555'"
                maxlength="17"
                inputmode="numeric"
                autocomplete="tel-national"
                aria-label="Alternate phone number"
                (input)="onAlternatePhoneInput($event)"
                (keydown)="onAlternatePhoneKeydown($event)"
                (paste)="onAlternatePhonePaste($event)" />
            </div>
            <div *ngIf="contactForm.get('alternatePhone')?.touched && contactForm.get('alternatePhone')?.errors?.['phoneInvalid']" class="text-danger mt-1 err-font">{{ errorMessage['M0017'] || 'Please enter a valid phone number.' }}</div>
            <div *ngIf="alternatePhoneExists" class="text-danger mt-1 err-font" role="alert">{{ errorMessage['M0087'] || 'The phone number entered is already on file.' }}</div>
          </div>
        </div>
        <div class="row mb-3 fullWidth ml-0 mr-0 mt-3">
          <div class="col text-right border-top pt-3 pr-0 manage-action">
            <button type="button" class="btn btn-outline-secondary mr-2" [disabled]="!contactFormDiffersFromSnapshot()" (click)="onContactReset()">Reset</button>
            <button type="button" class="btn btn-primary" [disabled]="contactForm.invalid || !contactFormDiffersFromSnapshot() || emailExists || recoveryEmailExists || phoneExists || alternatePhoneExists || contactRecoveryMatchesPrimary()" (click)="onContactUpdate()">Update</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Address panel -->
<div class="row ml-0 mr-0 lookup-user-personal-wrap">
  <div class="panel-blue">
    <div
      class="header"
      (click)="toggleAddressPanel()"
      tabindex="0"
      role="button"
      [attr.aria-expanded]="showAddressPanel"
      aria-controls="lookupAddressPanel"
      aria-label="Address section, toggle to expand or collapse">
      <span class="panel-title">Address</span>
      <button type="button" class="toggle-panel" *ngIf="showAddressPanel" (click)="toggleAddressPanel(); $event.stopPropagation()" aria-label="Collapse">
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </button>
      <button type="button" class="toggle-panel" *ngIf="!showAddressPanel" (click)="toggleAddressPanel(); $event.stopPropagation()" aria-label="Expand">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
    </div>
    <div class="panel-body" id="lookupAddressPanel" *ngIf="showAddressPanel">
      <form [formGroup]="addressForm" novalidate>
        <div class="current-user-personal-container mb-3">
          <h6 class="current-user-personal-title">Primary Address</h6>
        </div>
        <div class="row ml-0 mr-0">
          <div class="col-sm-12 col-md-3 col-lg-3 relPos countryHeight">
            <label for="lookup_addr_p_country">Country<span class="requiredfield text-danger">*</span></label>
            <div class="dropdown-clear-wrapper lookup-country-select">
              <select id="lookup_addr_p_country" class="formField" formControlName="primaryCountry"
                (change)="blurSelect($event)"
                [ngClass]="{ 'is-invalid': addressForm.get('primaryCountry')?.invalid && addressForm.get('primaryCountry')?.touched }"
                [matTooltip]="getSelectLabel(addressForm.get('primaryCountry')?.value, countryList)"
                matTooltipPosition="above"
                matTooltipClass="custom-tooltip">
                <option value="" hidden disabled selected>{{ placeholderMessage['P0015'] || 'Select' }}</option>
                <option *ngFor="let list of countryList" [value]="list.key">{{ list.value }}</option>
              </select>
            </div>
            <div *ngIf="addressForm.get('primaryCountry')?.touched && addressForm.get('primaryCountry')?.errors?.['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0021'] || 'Required.' }}</div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_addr_p_street">Street Address<span class="requiredfield text-danger">*</span></label>
            <input type="text" id="lookup_addr_p_street" class="formField" formControlName="primaryStreet" [placeholder]="placeholderMessage['P0011'] || 'Enter'" maxlength="60"
              (input)="onStreetAddressInput($event, 'primaryStreet')"
              (blur)="onStreetAddressBlur('primaryStreet')"
              [ngClass]="{ 'is-invalid': addressForm.get('primaryStreet')?.invalid && addressForm.get('primaryStreet')?.touched }" />
            <div *ngIf="addressForm.get('primaryStreet')?.touched && addressForm.get('primaryStreet')?.errors?.['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0018'] || 'Required.' }}</div>
            <div *ngIf="addressForm.get('primaryStreet')?.touched && (addressForm.get('primaryStreet')?.errors?.['pattern'] || addressForm.get('primaryStreet')?.errors?.['specialCharAtEnd'])" class="text-danger mt-1 err-font">{{ errorMessage['M0052'] || 'Invalid format.' }}</div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_addr_p_line2">Address Line 2</label>
            <input type="text" id="lookup_addr_p_line2" class="formField" formControlName="primaryLine2" [placeholder]="placeholderMessage['P0012'] || 'Enter'" maxlength="60"
              [ngClass]="{ 'is-invalid': addressForm.get('primaryLine2')?.invalid && addressForm.get('primaryLine2')?.touched }" />
            <div *ngIf="addressForm.get('primaryLine2')?.touched && addressForm.get('primaryLine2')?.errors?.['line2Length']" class="text-danger mt-1 err-font">{{ errorMessage['M0052'] || 'Invalid format.' }}</div>
            <div *ngIf="addressForm.get('primaryLine2')?.touched && addressForm.get('primaryLine2')?.errors?.['line2Pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0052'] || 'Invalid format.' }}</div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_addr_p_city">City<span class="requiredfield text-danger">*</span></label>
            <input type="text" id="lookup_addr_p_city" class="formField" formControlName="primaryCity" [placeholder]="placeholderMessage['P0013'] || 'Enter'"
              [ngClass]="{ 'is-invalid': addressForm.get('primaryCity')?.invalid && addressForm.get('primaryCity')?.touched }" />
            <div *ngIf="addressForm.get('primaryCity')?.touched && addressForm.get('primaryCity')?.errors?.['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0019'] || 'Required.' }}</div>
            <div *ngIf="addressForm.get('primaryCity')?.touched && !addressForm.get('primaryCity')?.errors?.['required'] && (addressForm.get('primaryCity')?.errors?.['pattern'] || addressForm.get('primaryCity')?.errors?.['minlength'] || addressForm.get('primaryCity')?.errors?.['maxlength'])" class="text-danger mt-1 err-font">{{ errorMessage['M0050'] || 'Invalid city format.' }}</div>
          </div>
        </div>
        <div class="row ml-0 mr-0 mt-2">
          <div class="col-sm-12 col-md-3 col-lg-3 relPos" *ngIf="isPrimaryCountryUS">
            <label for="lookup_addr_p_county">County<span class="requiredfield text-danger">*</span></label>
            <input type="text" id="lookup_addr_p_county" class="formField" formControlName="primaryCounty" [placeholder]="placeholderMessage['P0013'] || 'Enter'"
              [ngClass]="{ 'is-invalid': addressForm.get('primaryCounty')?.invalid && addressForm.get('primaryCounty')?.touched }" />
            <div *ngIf="addressForm.get('primaryCounty')?.touched && addressForm.get('primaryCounty')?.errors?.['required']" class="text-danger mt-1 err-font">{{ 'County is required.' }}</div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_addr_p_state">State<span class="requiredfield text-danger">*</span></label>
            <input type="text" id="lookup_addr_p_state" class="formField" formControlName="primaryState" [placeholder]="placeholderMessage['P0014'] || 'Enter'"
              [ngClass]="{ 'is-invalid': addressForm.get('primaryState')?.invalid && addressForm.get('primaryState')?.touched }" />
            <div *ngIf="addressForm.get('primaryState')?.touched && addressForm.get('primaryState')?.errors?.['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0020'] || 'Required.' }}</div>
            <div *ngIf="addressForm.get('primaryState')?.touched && !addressForm.get('primaryState')?.errors?.['required'] && (addressForm.get('primaryState')?.errors?.['pattern'] || addressForm.get('primaryState')?.errors?.['minlength'] || addressForm.get('primaryState')?.errors?.['maxlength'])" class="text-danger mt-1 err-font">{{ errorMessage['M0051'] || 'Invalid state format.' }}</div>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 relPos">
            <label for="lookup_addr_p_zip">Zip Code<span class="requiredfield text-danger">*</span></label>
            <input type="text" id="lookup_addr_p_zip" class="formField" formControlName="primaryZip"
              [attr.maxlength]="isPrimaryCountryUS ? 10 : null"
              [placeholder]="(placeholderMessage['P0016'] || 'Enter')"
              (input)="onPrimaryZipInput($event)"
              (blur)="onPrimaryZipBlur()"
              [ngClass]="{ 'is-invalid': addressForm.get('primaryZip')?.invalid && addressForm.get('primaryZip')?.touched }" />
            <div *ngIf="addressForm.get('primaryZip')?.touched && addressForm.get('primaryZip')?.errors?.['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0022'] || 'Required.' }}</div>
            <div *ngIf="addressForm.get('primaryZip')?.touched && (addressForm.get('primaryZip')?.errors?.['invalidZipLength'] || (addressForm.get('primaryZip')?.errors?.['pattern'] && isPrimaryCountryUS))" class="text-danger mt-1 err-font">{{ errorMessage['M0023'] || 'Invalid zip code.' }}</div>
            <div *ngIf="addressForm.get('primaryZip')?.touched && addressForm.get('primaryZip')?.errors?.['pattern'] && !isPrimaryCountryUS" class="text-danger mt-1 err-font">{{ errorMessage['M0023'] || 'Invalid zip code.' }}</div>
            <div *ngIf="addressForm.get('primaryZip')?.touched && addressForm.get('primaryZip')?.errors?.['allZeros']" class="text-danger mt-1 err-font">{{ errorMessage['M0023'] || 'Invalid zip code.' }}</div>
          </div>
        </div>
        <div class="row ml-0 mr-0 mt-3">
          <div class="col-12">
            <div class="lookup-mailing-same-row mb-0">
              <span class="lookup-mailing-same-input-wrap">
                <input
                  class="form-check-input lookup-mailing-same-checkbox"
                  type="checkbox"
                  id="lookup_addr_mailing_same"
                  formControlName="mailingSameAsAbove" />
              </span>
              <label class="lookup-mailing-same-caption mb-0" for="lookup_addr_mailing_same">Mailing address same as above</label>
            </div>
          </div>
        </div>
        <ng-container *ngIf="!addressForm.get('mailingSameAsAbove')?.value">
          <div class="current-user-personal-container mb-3 mt-3">
            <h6 class="current-user-personal-title">Mailing Address</h6>
          </div>
          <div class="row ml-0 mr-0">
            <div class="col-sm-12 col-md-3 col-lg-3 relPos countryHeight">
              <label for="lookup_addr_m_country">Country<span class="requiredfield text-danger">*</span></label>
              <div class="dropdown-clear-wrapper lookup-country-select">
                <select id="lookup_addr_m_country" class="formField" formControlName="mailingCountry"
                  (change)="blurSelect($event)"
                  [ngClass]="{ 'is-invalid': addressForm.get('mailingCountry')?.invalid && addressForm.get('mailingCountry')?.touched }"
                  [matTooltip]="getSelectLabel(addressForm.get('mailingCountry')?.value, countryList)"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip">
                  <option value="" hidden disabled selected>{{ placeholderMessage['P0015'] || 'Select' }}</option>
                  <option *ngFor="let list of countryList" [value]="list.key">{{ list.value }}</option>
                </select>
              </div>
              <div *ngIf="addressForm.get('mailingCountry')?.touched && addressForm.get('mailingCountry')?.errors?.['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0021'] || 'Required.' }}</div>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 relPos">
              <label for="lookup_addr_m_street">Mailing Address<span class="requiredfield text-danger">*</span></label>
              <input type="text" id="lookup_addr_m_street" class="formField" formControlName="mailingStreet" [placeholder]="placeholderMessage['P0011'] || 'Enter'" maxlength="60"
                (input)="onStreetAddressInput($event, 'mailingStreet')"
                (blur)="onStreetAddressBlur('mailingStreet')"
                [ngClass]="{ 'is-invalid': addressForm.get('mailingStreet')?.invalid && addressForm.get('mailingStreet')?.touched }" />
              <div *ngIf="addressForm.get('mailingStreet')?.touched && addressForm.get('mailingStreet')?.errors?.['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0018'] || 'Required.' }}</div>
              <div *ngIf="addressForm.get('mailingStreet')?.touched && (addressForm.get('mailingStreet')?.errors?.['pattern'] || addressForm.get('mailingStreet')?.errors?.['specialCharAtEnd'])" class="text-danger mt-1 err-font">{{ errorMessage['M0052'] || 'Invalid format.' }}</div>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 relPos">
              <label for="lookup_addr_m_line2">Address Line 2</label>
              <input type="text" id="lookup_addr_m_line2" class="formField" formControlName="mailingLine2" [placeholder]="placeholderMessage['P0012'] || 'Enter'" maxlength="60"
                [ngClass]="{ 'is-invalid': addressForm.get('mailingLine2')?.invalid && addressForm.get('mailingLine2')?.touched }" />
              <div *ngIf="addressForm.get('mailingLine2')?.touched && addressForm.get('mailingLine2')?.errors?.['line2Length']" class="text-danger mt-1 err-font">{{ errorMessage['M0052'] || 'Invalid format.' }}</div>
              <div *ngIf="addressForm.get('mailingLine2')?.touched && addressForm.get('mailingLine2')?.errors?.['line2Pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0052'] || 'Invalid format.' }}</div>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 relPos">
              <label for="lookup_addr_m_city">City<span class="requiredfield text-danger">*</span></label>
              <input type="text" id="lookup_addr_m_city" class="formField" formControlName="mailingCity" [placeholder]="placeholderMessage['P0013'] || 'Enter'"
                [ngClass]="{ 'is-invalid': addressForm.get('mailingCity')?.invalid && addressForm.get('mailingCity')?.touched }" />
              <div *ngIf="addressForm.get('mailingCity')?.touched && addressForm.get('mailingCity')?.errors?.['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0019'] || 'Required.' }}</div>
              <div *ngIf="addressForm.get('mailingCity')?.touched && !addressForm.get('mailingCity')?.errors?.['required'] && (addressForm.get('mailingCity')?.errors?.['pattern'] || addressForm.get('mailingCity')?.errors?.['minlength'] || addressForm.get('mailingCity')?.errors?.['maxlength'])" class="text-danger mt-1 err-font">{{ errorMessage['M0050'] || 'Invalid city format.' }}</div>
            </div>
          </div>
          <div class="row ml-0 mr-0 mt-2">
            <div class="col-sm-12 col-md-3 col-lg-3 relPos" *ngIf="isMailingCountryUS">
              <label for="lookup_addr_m_county">County<span class="requiredfield text-danger">*</span></label>
              <input type="text" id="lookup_addr_m_county" class="formField" formControlName="mailingCounty" [placeholder]="placeholderMessage['P0013'] || 'Enter'"
                [ngClass]="{ 'is-invalid': addressForm.get('mailingCounty')?.invalid && addressForm.get('mailingCounty')?.touched }" />
              <div *ngIf="addressForm.get('mailingCounty')?.touched && addressForm.get('mailingCounty')?.errors?.['required']" class="text-danger mt-1 err-font">{{ 'County is required.' }}</div>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 relPos">
              <label for="lookup_addr_m_state">State<span class="requiredfield text-danger">*</span></label>
              <input type="text" id="lookup_addr_m_state" class="formField" formControlName="mailingState" [placeholder]="placeholderMessage['P0014'] || 'Enter'"
                [ngClass]="{ 'is-invalid': addressForm.get('mailingState')?.invalid && addressForm.get('mailingState')?.touched }" />
              <div *ngIf="addressForm.get('mailingState')?.touched && addressForm.get('mailingState')?.errors?.['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0020'] || 'Required.' }}</div>
              <div *ngIf="addressForm.get('mailingState')?.touched && !addressForm.get('mailingState')?.errors?.['required'] && (addressForm.get('mailingState')?.errors?.['pattern'] || addressForm.get('mailingState')?.errors?.['minlength'] || addressForm.get('mailingState')?.errors?.['maxlength'])" class="text-danger mt-1 err-font">{{ errorMessage['M0051'] || 'Invalid state format.' }}</div>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 relPos">
              <label for="lookup_addr_m_zip">Zip Code<span class="requiredfield text-danger">*</span></label>
              <input type="text" id="lookup_addr_m_zip" class="formField" formControlName="mailingZip"
                [attr.maxlength]="isMailingCountryUS ? 10 : null"
                [placeholder]="(placeholderMessage['P0016'] || 'Enter')"
                (input)="onMailingZipInput($event)"
                (blur)="onMailingZipBlur()"
                [ngClass]="{ 'is-invalid': addressForm.get('mailingZip')?.invalid && addressForm.get('mailingZip')?.touched }" />
              <div *ngIf="addressForm.get('mailingZip')?.touched && addressForm.get('mailingZip')?.errors?.['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0022'] || 'Required.' }}</div>
              <div *ngIf="addressForm.get('mailingZip')?.touched && (addressForm.get('mailingZip')?.errors?.['invalidZipLength'] || (addressForm.get('mailingZip')?.errors?.['pattern'] && isMailingCountryUS))" class="text-danger mt-1 err-font">{{ errorMessage['M0023'] || 'Invalid zip code.' }}</div>
              <div *ngIf="addressForm.get('mailingZip')?.touched && addressForm.get('mailingZip')?.errors?.['pattern'] && !isMailingCountryUS" class="text-danger mt-1 err-font">{{ errorMessage['M0023'] || 'Invalid zip code.' }}</div>
              <div *ngIf="addressForm.get('mailingZip')?.touched && addressForm.get('mailingZip')?.errors?.['allZeros']" class="text-danger mt-1 err-font">{{ errorMessage['M0023'] || 'Invalid zip code.' }}</div>
            </div>
          </div>
        </ng-container>
        <!-- <p *ngIf="addressForm.get('mailingSameAsAbove')?.value" class="mailpraddress mb-2 mt-3" aria-live="polite">
          Mailing address matches your primary address.
        </p> -->
        <div class="row mb-3 fullWidth ml-0 mr-0 mt-3">
          <div class="col text-right border-top pt-3 pr-0 manage-action">
            <button type="button" class="btn btn-outline-secondary mr-2" [disabled]="addressForm.pristine" (click)="onAddressReset()">Reset</button>
            <button type="button" class="btn btn-primary" [disabled]="addressForm.invalid || addressForm.pristine" (click)="onAddressUpdate()">Update</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Name Change (contains Supporting Documents) -->
<div class="row ml-0 mr-0 lookup-user-personal-wrap">
  <div class="panel-blue">
    <div
      class="header d-flex justify-content-between align-items-center"
      (click)="toggleNameChangePanel()"
      tabindex="0"
      role="button"
      [attr.aria-expanded]="showNameChangePanel"
      aria-controls="lookupNameChangePanel"
      aria-label="Name Change section, toggle to expand or collapse">
      <span class="panel-title mb-0">Name Change</span>
      <button type="button" class="toggle-panel position-static" *ngIf="showNameChangePanel" (click)="toggleNameChangePanel(); $event.stopPropagation()" aria-label="Collapse">
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </button>
      <button type="button" class="toggle-panel position-static" *ngIf="!showNameChangePanel" (click)="toggleNameChangePanel(); $event.stopPropagation()" aria-label="Expand">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
    </div>
    <div class="panel-body" id="lookupNameChangePanel" *ngIf="showNameChangePanel">
      <!-- New Legal Name form -->
      <div class="current-prior-name-form-container">
        <h6 class="add-endorsement-current-lic-title">Add Name Change</h6>
        <form [formGroup]="nameChangeForm" novalidate>
          <div class="row ml-0 mr-0">
            <div class="col-sm-12 col-md-3 col-lg-3 relPos">
              <label for="lookup_new_first">New Legal First Name<span class="requiredfield text-danger">*</span></label>
              <input type="text" id="lookup_new_first" class="formField" formControlName="newLegalFirstName" [placeholder]="placeholderMessage['P0001'] || 'Enter'"
                maxlength="30" minlength="2" autocomplete="given-name"
                [attr.aria-invalid]="nameChangeForm.get('newLegalFirstName')?.touched && nameChangeForm.get('newLegalFirstName')?.invalid ? 'true' : null"
                [attr.aria-describedby]="nameChangeForm.get('newLegalFirstName')?.touched && nameChangeForm.get('newLegalFirstName')?.invalid ? 'lookup_name_new_first_err' : null"
                [ngClass]="{ 'is-invalid': nameChangeForm.get('newLegalFirstName')?.invalid && nameChangeForm.get('newLegalFirstName')?.touched }" />
              <div id="lookup_name_new_first_err" *ngIf="nameChangeForm.get('newLegalFirstName')?.touched && nameChangeForm.get('newLegalFirstName')?.errors as errors">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0001'] || 'Required' }}</div>
                <div *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])" class="text-danger mt-1 err-font">{{ errorMessage['M0002'] || 'Invalid format or length.' }}</div>
              </div>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 relPos">
              <label for="lookup_new_middle">New Legal Middle Name</label>
              <input type="text" id="lookup_new_middle" class="formField" formControlName="newLegalMiddleName" [placeholder]="placeholderMessage['P0002'] || 'Enter'"
                maxlength="30" autocomplete="additional-name"
                [attr.aria-invalid]="nameChangeForm.get('newLegalMiddleName')?.touched && nameChangeForm.get('newLegalMiddleName')?.invalid ? 'true' : null"
                [attr.aria-describedby]="nameChangeForm.get('newLegalMiddleName')?.touched && nameChangeForm.get('newLegalMiddleName')?.invalid ? 'lookup_name_new_middle_err' : null"
                [ngClass]="{ 'is-invalid': nameChangeForm.get('newLegalMiddleName')?.invalid && nameChangeForm.get('newLegalMiddleName')?.touched }" />
              <div id="lookup_name_new_middle_err" *ngIf="nameChangeForm.get('newLegalMiddleName')?.touched && nameChangeForm.get('newLegalMiddleName')?.errors as errors">
                <div *ngIf="errors['pattern'] || errors['maxlength']" class="text-danger mt-1 err-font">{{ errorMessage['M0003'] || 'Invalid format or length.' }}</div>
              </div>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 relPos">
              <label for="lookup_new_last">New Legal Last Name<span class="requiredfield text-danger">*</span></label>
              <input type="text" id="lookup_new_last" class="formField" formControlName="newLegalLastName" [placeholder]="placeholderMessage['P0003'] || 'Enter'"
                maxlength="30" minlength="2" autocomplete="family-name"
                [attr.aria-invalid]="nameChangeForm.get('newLegalLastName')?.touched && nameChangeForm.get('newLegalLastName')?.invalid ? 'true' : null"
                [attr.aria-describedby]="nameChangeForm.get('newLegalLastName')?.touched && nameChangeForm.get('newLegalLastName')?.invalid ? 'lookup_name_new_last_err' : null"
                [ngClass]="{ 'is-invalid': nameChangeForm.get('newLegalLastName')?.invalid && nameChangeForm.get('newLegalLastName')?.touched }" />
              <div id="lookup_name_new_last_err" *ngIf="nameChangeForm.get('newLegalLastName')?.touched && nameChangeForm.get('newLegalLastName')?.errors as errors">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0004'] || 'Required' }}</div>
                <div *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])" class="text-danger mt-1 err-font">{{ errorMessage['M0005'] || 'Invalid format or length.' }}</div>
              </div>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 relPos">
              <label for="lookup_new_suffix">New Legal Suffix</label>
              <div class="dropdown-clear-wrapper lookup-name-suffix-select">
                <select id="lookup_new_suffix" class="formField form-control" formControlName="newLegalSuffix"
                  (change)="blurSelect($event)"
                  [style.color]="nameChangeForm.get('newLegalSuffix')?.value == null ? '#757575' : null"
                  [ngClass]="{ 'empty-select': nameChangeForm.get('newLegalSuffix')?.value == null }"
                  [matTooltip]="getSelectLabel(nameChangeForm.get('newLegalSuffix')?.value, suffixList)"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip">
                  <option [ngValue]="null">{{ placeholderMessage['P0027'] || 'Select Suffix' }}</option>
                  <option *ngFor="let s of suffixList" [ngValue]="s.key" [attr.aria-label]="getSuffixAriaLabel(s.value)">{{ s.value }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row mb-3 fullWidth ml-0 mr-0 mt-3">
            <div class="col text-right border-top pt-3 pr-0 manage-action">
              <button type="button" class="btn btn-outline-secondary mr-2" [disabled]="nameChangeForm.pristine" (click)="onNameChangeReset()">Reset</button>
              <button type="button" class="btn btn-primary" [disabled]="nameChangeForm.invalid" (click)="onNameChangeUpdate()">Update</button>
            </div>
          </div>
        </form>
      </div>

      <!-- Prior Names -->
      <h6 class="document-grid-title">Prior Names</h6>

      <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap gap-2 py-2 px-2" (click)="$event.stopPropagation()">
          <div class="lookup-personal-grid-actions-wrap d-flex align-items-center">
          <app-grid-actions
            [actions]="lookupPersonalExportColumnChooserActions"
            [showColumnChooser]="showPriorNamesColumnChooser"
            [allColumns]="priorNamesAllColumns"
            [visibleColumns]="priorNamesColumnVisibility"
            (exportClick)="onPriorNamesExportExcel()"
            (columnChooserToggle)="togglePriorNamesColumnChooser()"
            (columnToggle)="onPriorNameGridColumnToggle($event)"
            (columnChooserClose)="closePriorNamesColumnChooser()">
          </app-grid-actions>
        </div>
        <button type="button" class="btn btn-primary btn-sm addpriporname" *ngIf="!showAddPriorForm" (click)="onAddPriorName()">
          <span class="material-symbols-outlined">add_circle</span> Add Prior Name
        </button>
      </div>
      </div>

      <div *ngIf="showAddPriorForm" class="current-prior-name-form-container" (click)="$event.stopPropagation()">
        <h6 class="add-endorsement-current-lic-title">Add Prior Name</h6>
        <form [formGroup]="addPriorNameForm" novalidate>
          <div
            *ngIf="shouldShowAddPriorNameG0067Info()"
            class="alert alert-info small mb-3"
            role="status"
            aria-live="polite"
            id="lookup_add_prior_info_g0067">
            {{ informationMessage['G0067'] || 'This prior name combination is already listed for this person.' }}
          </div>
          <div class="row ml-0 mr-0">
            <div class="col-sm-12 col-md-3 col-lg-3 relPos">
              <label for="lookup_prior_first">First Name<span class="requiredfield text-danger">*</span></label>
              <input id="lookup_prior_first" type="text" class="formField" formControlName="priorFirst" [placeholder]="placeholderMessage['P0001'] || 'Enter'"
                maxlength="30" minlength="2" autocomplete="given-name"
                [attr.aria-invalid]="addPriorNameForm.get('priorFirst')?.touched && addPriorNameForm.get('priorFirst')?.invalid ? 'true' : null"
                [attr.aria-describedby]="addPriorNameForm.get('priorFirst')?.touched && addPriorNameForm.get('priorFirst')?.invalid ? 'lookup_prior_first_err' : null"
                [ngClass]="{ 'is-invalid': addPriorNameForm.get('priorFirst')?.invalid && addPriorNameForm.get('priorFirst')?.touched }" />
              <div id="lookup_prior_first_err" *ngIf="addPriorNameForm.get('priorFirst')?.touched && addPriorNameForm.get('priorFirst')?.errors as errors">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0001'] || 'Required' }}</div>
                <div *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])" class="text-danger mt-1 err-font">{{ errorMessage['M0002'] || 'Invalid format or length.' }}</div>
              </div>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 relPos">
              <label for="lookup_prior_middle">Middle Name</label>
              <input id="lookup_prior_middle" type="text" class="formField" formControlName="priorMiddle" [placeholder]="placeholderMessage['P0002'] || 'Enter'"
                maxlength="30" autocomplete="additional-name"
                [attr.aria-invalid]="addPriorNameForm.get('priorMiddle')?.touched && addPriorNameForm.get('priorMiddle')?.invalid ? 'true' : null"
                [attr.aria-describedby]="addPriorNameForm.get('priorMiddle')?.touched && addPriorNameForm.get('priorMiddle')?.invalid ? 'lookup_prior_middle_err' : null"
                [ngClass]="{ 'is-invalid': addPriorNameForm.get('priorMiddle')?.invalid && addPriorNameForm.get('priorMiddle')?.touched }" />
              <div id="lookup_prior_middle_err" *ngIf="addPriorNameForm.get('priorMiddle')?.touched && addPriorNameForm.get('priorMiddle')?.errors as errors">
                <div *ngIf="errors['pattern'] || errors['maxlength']" class="text-danger mt-1 err-font">{{ errorMessage['M0003'] || 'Invalid format or length.' }}</div>
              </div>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 relPos">
              <label for="lookup_prior_last">Last Name<span class="requiredfield text-danger">*</span></label>
              <input id="lookup_prior_last" type="text" class="formField" formControlName="priorLast" [placeholder]="placeholderMessage['P0003'] || 'Enter'"
                maxlength="30" minlength="2" autocomplete="family-name"
                [attr.aria-invalid]="addPriorNameForm.get('priorLast')?.touched && addPriorNameForm.get('priorLast')?.invalid ? 'true' : null"
                [attr.aria-describedby]="addPriorNameForm.get('priorLast')?.touched && addPriorNameForm.get('priorLast')?.invalid ? 'lookup_prior_last_err' : null"
                [ngClass]="{ 'is-invalid': addPriorNameForm.get('priorLast')?.invalid && addPriorNameForm.get('priorLast')?.touched }" />
              <div id="lookup_prior_last_err" *ngIf="addPriorNameForm.get('priorLast')?.touched && addPriorNameForm.get('priorLast')?.errors as errors">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0004'] || 'Required' }}</div>
                <div *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])" class="text-danger mt-1 err-font">{{ errorMessage['M0005'] || 'Invalid format or length.' }}</div>
              </div>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3 relPos">
              <label for="lookup_prior_suffix">Suffix</label>
              <div class="dropdown-clear-wrapper lookup-name-suffix-select">
                <select id="lookup_prior_suffix" class="formField form-control" formControlName="priorSuffix"
                  (change)="blurSelect($event)"
                  [style.color]="addPriorNameForm.get('priorSuffix')?.value == null ? '#757575' : null"
                  [ngClass]="{ 'empty-select': addPriorNameForm.get('priorSuffix')?.value == null }"
                  [matTooltip]="getSelectLabel(addPriorNameForm.get('priorSuffix')?.value, suffixList)"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip">
                  <option [ngValue]="null">{{ placeholderMessage['P0027'] || 'Select Suffix' }}</option>
                  <option *ngFor="let s of suffixList" [ngValue]="s.key" [attr.aria-label]="getSuffixAriaLabel(s.value)">{{ s.value }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row mb-2 fullWidth ml-0 mr-0 mt-2">
            <div class="col text-right pr-0 manage-action">
              <button type="button" class="btn btn-outline-primary mr-2 lookup-outline-cancel-transparent" (click)="onCancelAddPriorName()">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm addpriporname" [disabled]="addPriorNameForm.invalid" (click)="onSubmitAddPriorName()">
                <span class="material-symbols-outlined">add_circle</span> Add
              </button>
            </div>
          </div>
        </form>
      </div>

      <div class="tab-content border rounded my-applications-container p-2 mx-2 mb-2" style="margin-left:0;margin-right:0;">
        <app-data-grid #priorNamesGrid [config]="priorNamesGridConfig" [activeTab]="'personal'" [wordWrapEnabled]="false">
          <ng-template #actionsTemplate let-data let-rowIndex="index">
            <div class="action-buttons-container" [attr.data-row]="rowIndex" role="group" [attr.aria-label]="'Actions for prior name ' + (data.first_name ?? '')">
              <span class="action-span-wrapper">
                <button type="button" class="action-icon-button" matTooltip="Edit" matTooltipPosition="above"
                  (click)="onEditPriorNameRow(data); $event.stopPropagation()">
                  <!-- <img src="assets/images/neveda-images/edit-icon.svg" alt="" width="20" height="20" aria-hidden="true" /> -->
                    <svg width="24" height="24" viewBox="4 4 26 26" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M10.3077 25.501C9.80258 25.501 9.375 25.326 9.025 24.976C8.675 24.626 8.5 24.1984 8.5 23.6933V10.3087C8.5 9.80358 8.675 9.376 9.025 9.026C9.375 8.676 9.80258 8.501 10.3077 8.501H17.1598C17.4098 8.501 17.5973 8.5795 17.7223 8.7365C17.8473 8.89367 17.9098 9.06517 17.9098 9.251C17.9098 9.43683 17.8447 9.60833 17.7145 9.7655C17.5843 9.9225 17.3942 10.001 17.1442 10.001H10.3077C10.2307 10.001 10.1603 10.0331 10.0963 10.0972C10.0321 10.1612 10 10.2317 10 10.3087V23.6933C10 23.7703 10.0321 23.8407 10.0963 23.9047C10.1603 23.9689 10.2307 24.001 10.3077 24.001H23.6923C23.7692 24.001 23.8398 23.9689 23.9038 23.9047C23.9679 23.8407 24 23.7703 24 23.6933V16.7933C24 16.5433 24.0785 16.3558 24.2355 16.2308C24.3927 16.1058 24.5642 16.0433 24.75 16.0433C24.9358 16.0433 25.1073 16.1058 25.2645 16.2308C25.4215 16.3558 25.5 16.5433 25.5 16.7933V23.6933C25.5 24.1984 25.325 24.626 24.975 24.976C24.625 25.326 24.1974 25.501 23.6923 25.501H10.3077ZM14.5 18.597V16.8165C14.5 16.5753 14.5468 16.3436 14.6405 16.1212C14.734 15.8987 14.8628 15.7055 15.027 15.5415L23.5598 7.00875C23.7148 6.85358 23.8853 6.74042 24.0712 6.66925C24.2571 6.59808 24.4462 6.5625 24.6385 6.5625C24.8347 6.5625 25.0231 6.59808 25.2038 6.66925C25.3846 6.74042 25.5493 6.85033 25.698 6.999L26.9538 8.251C27.0986 8.40617 27.2098 8.57733 27.2875 8.7645C27.365 8.95167 27.4038 9.14142 27.4038 9.33375C27.4038 9.52608 27.3708 9.71258 27.3048 9.89325C27.2388 10.0741 27.1282 10.242 26.973 10.397L18.4115 18.9587C18.2473 19.1227 18.0541 19.2542 17.8318 19.353C17.6093 19.4517 17.3775 19.501 17.1365 19.501H15.404C15.1462 19.501 14.9311 19.4147 14.7588 19.2422C14.5863 19.0699 14.5 18.8548 14.5 18.597ZM16 18.001H17.2463L23.4788 11.7682L22.8558 11.1452L22.1885 10.503L16 16.6915V18.001Z"
                                            fill="#444444" />
                                    </svg>
                </button>
              </span>
              <span class="action-span-wrapper ml-1">
                <button type="button" class="action-icon-button" matTooltip="Delete" matTooltipPosition="above"
                  (click)="onDeletePriorNameRow(data); $event.stopPropagation()">
                  <img src="assets/images/neveda-images/delete-icon.svg" alt="" width="20" height="20" aria-hidden="true" />
                </button>
              </span>
            </div>
          </ng-template>
        </app-data-grid>
      </div>

      <h6 class="document-grid-title">Supporting Documents</h6>

      <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap gap-2 py-2 px-2" (click)="$event.stopPropagation()">
          <div class="lookup-personal-grid-actions-wrap d-flex align-items-center">
            <app-grid-actions
              [actions]="lookupPersonalExportColumnChooserActions"
              [showColumnChooser]="showSupportingDocumentsColumnChooser"
            [visibleColumns]="supportingDocumentsColumnVisibility"
            (exportClick)="onSupportingDocumentsExportExcel()"
            (columnChooserToggle)="toggleSupportingDocumentsColumnChooser()"
            (columnToggle)="onSupportingDocumentsColumnToggle($event)"
            (columnChooserClose)="closeSupportingDocumentsColumnChooser()">
          </app-grid-actions>
        </div>
        <button type="button" class="btn btn-primary btn-sm addpriporname" (click)="onSupportingDocumentsUpload()">
          <span class="material-symbols-outlined">upload</span>Upload
        </button>
      </div>
      </div>
      <div class="tab-content border rounded my-applications-container p-2" style="margin-left:0;margin-right:0;">
        <app-data-grid
          #supportingDocumentsGrid
          [config]="supportingDocumentsGridConfig"
          [activeTab]="'personal'"
          [statusDataField]="'document_status'"
          [submittedStatusValues]="['Uploaded', 'Verified', 'uploaded', 'verified']"
          [wordWrapEnabled]="false">
          <ng-template #actionsTemplate let-data let-rowIndex="index">
            <div class="action-buttons-container" [attr.data-row]="rowIndex" role="group" [attr.aria-label]="'Actions for ' + (data.file_name ?? 'document')">
              <span class="action-span-wrapper">
                <button type="button" class="action-icon-button"
                  [disabled]="!supportingDocumentHasValidId(data)"
                  matTooltip="View"
                  matTooltipPosition="above"
                  (click)="viewSupportingDocument(data); $event.stopPropagation()">
                  <span class="material-symbols-outlined">visibility</span>
                </button>
              </span>
              <span class="action-span-wrapper ml-1">
                <button type="button" class="action-icon-button"
                  [disabled]="!supportingDocumentHasValidId(data)"
                  matTooltip="Download"
                  matTooltipPosition="above"
                  (click)="downloadSupportingDocument(data); $event.stopPropagation()">
                  <span class="material-symbols-outlined">download</span>
                </button>
              </span>
            </div>
          </ng-template>
        </app-data-grid>
      </div>
    </div>
  </div>
</div>

<!-- Transaction History -->
<div class="row ml-0 mr-0 lookup-user-personal-wrap">
  <div class="panel-blue">
    <div
      class="header d-flex justify-content-between align-items-center"
      (click)="toggleTransactionHistoryPanel()"
      tabindex="0"
      role="button"
      [attr.aria-expanded]="showTransactionHistoryPanel"
      aria-controls="lookupTransactionPanel">
      <span class="panel-title mb-0">Transaction History</span>
      <button type="button" class="toggle-panel position-static" *ngIf="showTransactionHistoryPanel" (click)="toggleTransactionHistoryPanel(); $event.stopPropagation()" aria-label="Collapse">
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </button>
      <button type="button" class="toggle-panel position-static" *ngIf="!showTransactionHistoryPanel" (click)="toggleTransactionHistoryPanel(); $event.stopPropagation()" aria-label="Expand">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
    </div>
    <div class="panel-body" id="lookupTransactionPanel" *ngIf="showTransactionHistoryPanel">
      <!-- Hide export, column chooser, and Add Transaction while the add form is open (Figma). -->
      <div *ngIf="!showAddTransactionForm" class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap gap-2 py-2 px-2" (click)="$event.stopPropagation()">
        <div class="lookup-personal-grid-actions-wrap d-flex align-items-center">
          <app-grid-actions
            [actions]="lookupPersonalExportColumnChooserActions"
            [showColumnChooser]="showTransactionHistoryColumnChooser"
            [allColumns]="transactionHistoryAllColumns"
            [visibleColumns]="transactionHistoryColumnVisibility"
            (exportClick)="onTransactionHistoryDownload()"
            (columnChooserToggle)="toggleTransactionHistoryColumnChooser()"
            (columnToggle)="onTransactionHistoryGridColumnToggle($event)"
            (columnChooserClose)="closeTransactionHistoryColumnChooser()">
          </app-grid-actions>
        </div>
        <button type="button" class="btn btn-primary btn-sm" *ngIf="canAddManualTransaction" (click)="onTransactionHistoryAdd()">
          <i class="fa fa-plus mr-1" aria-hidden="true"></i> Add Transaction
        </button>
      </div>

      <div *ngIf="showAddTransactionForm" class="current-prior-name-form-container" (click)="$event.stopPropagation()">
                <h6 class="add-endorsement-current-lic-title">Add Transaction</h6>
        <!-- <h6 class="lookup-add-txn-title mb-3 mt-0">Add Transaction</h6> -->
        <form [formGroup]="addTransactionForm" novalidate>
          <div class="row ml-0 mr-0">
            <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <label for="lookup_txn_type">Transaction Type<span class="requiredfield text-danger">*</span></label>
              <div class="dropdown-clear-wrapper lookup-identity-select-wrap">
                <select id="lookup_txn_type" class="formField form-control" formControlName="transactionType" required
                  (change)="blurSelect($event)"
                  [ngClass]="{ 'is-invalid': addTransactionForm.get('transactionType')?.invalid && addTransactionForm.get('transactionType')?.touched }"
                  [matTooltip]="getSelectLabel(addTransactionForm.get('transactionType')?.value, addTransactionTypeLookupOptions)"
                  matTooltipPosition="above"
                  matTooltipClass="custom-tooltip">
                  <option value="">{{ placeholderMessage['P0139'] || 'Select' }}</option>
                  <option *ngFor="let opt of addTransactionTypeLookupOptions" [value]="opt.key">{{ opt.value }}</option>
                </select>
              </div>
              <div *ngIf="addTransactionForm.get('transactionType')?.touched && addTransactionForm.get('transactionType')?.errors?.['required']" class="text-danger mt-1 err-font small">{{ errorMessage['M0179'] || 'Required' }}</div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <label for="lookup_txn_app">Application ID<span class="requiredfield text-danger" *ngIf="addTransactionForm.get('transactionType')?.value === addTxnRefundLookupKey">*</span></label>
              <div class="dropdown-clear-wrapper lookup-identity-select-wrap">
                <select id="lookup_txn_app" class="formField form-control" formControlName="applicationKey"
                  (change)="blurSelect($event)"
                  [ngClass]="{ 'is-invalid': addTransactionForm.get('applicationKey')?.invalid && addTransactionForm.get('applicationKey')?.touched }">
                  <option value="">{{ placeholderMessage['P0140'] || 'Select' }}</option>
                  <option *ngFor="let opt of addTransactionApplicationOptions" [value]="opt.key">{{ opt.displayId || opt.key }}</option>
                </select>
              </div>
              <div *ngIf="addTransactionForm.get('applicationKey')?.touched && addTransactionForm.get('applicationKey')?.errors?.['required']" class="text-danger mt-1 err-font small">{{ errorMessage['M0180'] || 'Required' }}</div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <label for="lookup_txn_revenue">Revenue Code Description<span class="requiredfield text-danger" *ngIf="addTransactionForm.get('transactionType')?.value === addTxnRefundLookupKey"> *</span></label>
              <mat-form-field class="w-100 lookup-txn-revenue-multiselect" appearance="outline" floatLabel="never" subscriptSizing="dynamic"
                [style.opacity]="addTransactionForm.get('revenueKeys')?.disabled ? '0.5' : '1'"
                [style.pointer-events]="addTransactionForm.get('revenueKeys')?.disabled ? 'none' : 'auto'"
                [matTooltip]="getMultiSelectLabel(addTransactionForm.get('revenueKeys')?.value, addTransactionRevenueOptions)"
                matTooltipPosition="above"
                matTooltipClass="custom-tooltip">
                <mat-select id="lookup_txn_revenue" formControlName="revenueKeys" multiple [placeholder]="placeholderMessage['P0143'] || 'Select'">
                  <mat-option *ngFor="let r of addTransactionRevenueOptions" [value]="r.key" [disabled]="r.disabled === true">{{ r.label }} ({{ r.sumAmount | number : '1.2-2' }})</mat-option>
                </mat-select>
                <mat-error *ngIf="addTransactionForm.get('revenueKeys')?.errors?.['revenueRequired']">{{ errorMessage['M0183'] || 'Select at least one revenue line for Refund.' }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <label for="lookup_txn_voucher">Voucher Number</label>
              <input id="lookup_txn_voucher" type="text" class="formField" formControlName="voucherNumber" maxlength="60" autocomplete="off"
                [placeholder]="placeholderMessage['P0141'] || 'Enter'"
                [ngClass]="{ 'is-invalid': addTransactionForm.get('voucherNumber')?.invalid && addTransactionForm.get('voucherNumber')?.touched }" />
              <div *ngIf="addTransactionForm.get('voucherNumber')?.touched && addTransactionForm.get('voucherNumber')?.errors?.['voucherLength']" class="text-danger mt-1 err-font small">
                Voucher number must be between 3 and 60 characters.
              </div>
              <div *ngIf="addTransactionForm.get('voucherNumber')?.touched && addTransactionForm.get('voucherNumber')?.errors?.['voucherPattern']" class="text-danger mt-1 err-font small">
                Only letters, numbers, spaces, and . , - ' # / are allowed.
              </div>
            </div>
          </div>
          <div class="row ml-0 mr-0">
            <div class="col-sm-12 col-md-6 col-lg-3 relPos mb-2">
              <label for="lookup_txn_amount">Amount<span class="requiredfield text-danger">*</span></label>
              <div
                class="lookup-txn-amount-field"
                [class.lookup-txn-amount-field--disabled]="addTransactionForm.get('transactionType')?.value === addTxnRefundLookupKey">
                <span class="lookup-txn-amount-prefix" aria-hidden="true">$</span>
                <input
                  id="lookup_txn_amount"
                  type="text"
                  class="formField lookup-txn-amount-input"
                  formControlName="amount"
                  [placeholder]="placeholderMessage['P0142'] || '0.00'"
                  inputmode="decimal"
                  autocomplete="off"
                  (blur)="onAddTransactionAmountBlur()"
                  [readOnly]="addTransactionForm.get('transactionType')?.value === addTxnRefundLookupKey"
                  [attr.aria-readonly]="addTransactionForm.get('transactionType')?.value === addTxnRefundLookupKey ? 'true' : null"
                  [ngClass]="{
                    'is-invalid': addTransactionForm.get('amount')?.invalid && addTransactionForm.get('amount')?.touched,
                    'lookup-txn-amount-input--disabled': addTransactionForm.get('transactionType')?.value === addTxnRefundLookupKey
                  }" />
              </div>
              <div *ngIf="addTransactionForm.get('amount')?.touched && addTransactionForm.get('amount')?.errors?.['required']" class="text-danger mt-1 err-font small">{{ errorMessage['M0181'] || 'Required' }}</div>
              <div *ngIf="addTransactionForm.get('amount')?.touched && addTransactionForm.get('amount')?.errors?.['maxDecimals']" class="text-danger mt-1 err-font small">{{ errorMessage['M0184'] || 'Amount may have at most two decimal places.' }}</div>
              <div *ngIf="addTransactionForm.get('amount')?.touched && addTransactionForm.get('amount')?.errors?.['amountFormat']" class="text-danger mt-1 err-font small">{{ errorMessage['M0185'] || 'Enter a valid amount.' }}</div>
              <div *ngIf="addTransactionForm.get('amount')?.touched && addTransactionForm.get('amount')?.errors?.['maxRefund']" class="text-danger mt-1 err-font small">Amount must match the total refundable for the selected revenue lines.</div>
            </div>
          </div>
          <!-- Figma: Cancel (outline) left, Save (primary) right — avoid parent .manage-action flex quirks -->
          <div class="row mb-2 fullWidth ml-0 mr-0 mt-2">
            <div id="lookup-add-txn-form-actions" class="col pr-0 d-flex justify-content-end align-items-center lookup-add-txn-actions">
              <button type="button" class="btn btn-outline-primary lookup-add-txn-btn-cancel" (click)="onCancelAddTransaction()">Cancel</button>
              <button type="button" class="btn btn-primary lookup-add-txn-btn-save" [disabled]="addTransactionForm.invalid" (click)="onSaveAddTransaction()">Save</button>
            </div>
          </div>
        </form>
      </div>

      <div class="tab-content border rounded my-applications-container p-2" style="margin-left:0;margin-right:0;">
        <app-data-grid
          #transactionHistoryGrid
          [config]="transactionHistoryGridConfig"
          [activeTab]="'personal'"
          [statusDataField]="'transactionStatus'"
          [submittedStatusValues]="['Authorized']"
          [onApplicationClick]="onLookupApplicationIdClick" 
          [wordWrapEnabled]="false">
          <ng-template #actionsTemplate let-data let-rowIndex="index">
            <div class="action-buttons-container" [attr.data-row]="rowIndex" role="group" [attr.aria-label]="'Actions for transaction ' + (data.paymentTransactionId ?? '')">
              <ng-container *ngIf="showTransactionReceiptActions(data)">
                <span class="action-span-wrapper">
                  <button type="button" class="action-icon-button"
                    matTooltip="View Receipt"
                    matTooltipPosition="above"
                    [attr.aria-label]="'View receipt for transaction ' + (data.paymentTransactionId ?? '')"
                    (click)="viewTransactionReceipt(data); $event.stopPropagation()">
                    <span class="material-symbols-outlined">visibility</span>
                  </button>
                </span>
                <span class="action-span-wrapper ml-1">
                  <button type="button" class="action-icon-button"
                    matTooltip="Download Receipt"
                    matTooltipPosition="above"
                    [attr.aria-label]="'Download receipt for transaction ' + (data.paymentTransactionId ?? '')"
                    (click)="downloadTransactionReceipt(data); $event.stopPropagation()">
                    <span class="material-symbols-outlined">download</span>
                  </button>
                </span>
              </ng-container>
            </div>
          </ng-template>
        </app-data-grid>
      </div>
    </div>
  </div>
</div>

<!-- Payment Breakdown -->
<div class="row ml-0 mr-0 lookup-user-personal-wrap">
  <div class="panel-blue">
    <div
      class="header d-flex justify-content-between align-items-center"
      (click)="togglePaymentBreakdownPanel()"
      tabindex="0"
      role="button"
      [attr.aria-expanded]="showPaymentBreakdownPanel"
      aria-controls="lookupPaymentBreakdownPanel">
      <span class="panel-title mb-0">Payment Breakdown</span>
      <button type="button" class="toggle-panel position-static" *ngIf="showPaymentBreakdownPanel" (click)="togglePaymentBreakdownPanel(); $event.stopPropagation()" aria-label="Collapse">
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </button>
      <button type="button" class="toggle-panel position-static" *ngIf="!showPaymentBreakdownPanel" (click)="togglePaymentBreakdownPanel(); $event.stopPropagation()" aria-label="Expand">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
    </div>
    <div class="panel-body" id="lookupPaymentBreakdownPanel" *ngIf="showPaymentBreakdownPanel">
      <div class="lookup-datagrid-toolbar d-flex justify-content-end align-items-center flex-wrap gap-2 py-2 px-2" (click)="$event.stopPropagation()">
        <div class="lookup-personal-grid-actions-wrap d-flex align-items-center">
          <app-grid-actions
            [actions]="lookupPersonalExportColumnChooserActions"
            [showColumnChooser]="showPaymentBreakdownColumnChooser"
            [allColumns]="paymentBreakdownAllColumns"
            [visibleColumns]="paymentBreakdownColumnVisibility"
            (exportClick)="onPaymentBreakdownExportExcel()"
            (columnChooserToggle)="togglePaymentBreakdownColumnChooser()"
            (columnToggle)="onPaymentBreakdownColumnToggle($event)"
            (columnChooserClose)="closePaymentBreakdownColumnChooser()">
          </app-grid-actions>
        </div>
      </div>
      <div class="tab-content border rounded my-applications-container p-2" style="margin-left:0;margin-right:0;">
        <app-data-grid
          #paymentBreakdownGrid
          [config]="paymentBreakdownGridConfig"
          [activeTab]="'personal'"
          [onApplicationClick]="onLookupApplicationIdClick"
          [wordWrapEnabled]="false">
        </app-data-grid>
      </div>
    </div>
  </div>
</div>

<!-- Staff upload: warning is ModalComponent; then Proof of Photo Identification file -->
<ng-template #staffUploadFilesTpl let-modal>
  <div class="modal-header border-bottom align-items-center">
    <h4 class="modal-title mb-0 font-weight-bold text-dark">Upload Files</h4>
    <button type="button" class="close" aria-label="Close" (click)="showCancelUploadConfirmation()" [disabled]="staffProfileUploading">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group mb-2">
      <label class="font-weight-bold d-block">Supporting Document<span class="text-danger">*</span></label>
      <input
        #staffProfileFileInput
        type="file"
        class="d-none"
        [accept]="staffProfileFileAccept"
        (change)="onStaffProfileFileInputChange($event)"
        [disabled]="staffProfileUploading" />
      <div
        class="lookup-staff-upload-dropzone text-center p-4 rounded"
        [class.lookup-staff-upload-dropzone--active]="staffProfileDropzoneActive"
        (dragover)="onStaffProfileDragOver($event)"
        (dragleave)="onStaffProfileDragLeave($event)"
        (drop)="onStaffProfileDrop($event)"
        (click)="triggerStaffProfileFilePicker(staffProfileFileInput)"
        role="button"
        tabindex="0"
        (keydown.enter)="triggerStaffProfileFilePicker(staffProfileFileInput)"
        (keydown.space)="$event.preventDefault(); triggerStaffProfileFilePicker(staffProfileFileInput)">
        <div class="lookup-staff-upload-icon rounded-circle mx-auto mb-2 d-flex align-items-center justify-content-center">
          <span class="material-symbols-outlined"> upload </span>
        </div>
        <div class="lookup-staff-upload-hint">
          Drag &amp; drop or
          <a class="lookup-staff-choose-link" (click)="$event.preventDefault(); $event.stopPropagation(); triggerStaffProfileFilePicker(staffProfileFileInput)">choose file</a>
          to upload
        </div>
      </div>
      <div class="lookup-staff-file-row mt-3 d-flex align-items-center  pt-3" *ngIf="staffProfileUploadFile; else noStaffFile">
        <i class="fa fa-file-text text-primary mr-2" aria-hidden="true"></i>
        <span class="flex-grow-1 text-truncate">{{ staffProfileUploadFile.name }}</span>
        <button
          type="button"
          class="btn btn-link btn-sm py-0"
          (click)="clearStaffProfileUploadFile(); $event.stopPropagation()"
          [disabled]="staffProfileUploading">
          Remove
        </button>
      </div>
      <ng-template #noStaffFile>
        <!-- <div class="lookup-staff-file-row mt-3 d-flex align-items-center text-muted border-top pt-3">
          <i class="fa fa-file-o text-primary mr-2" aria-hidden="true"></i>
          <span>No file uploaded</span>
        </div> -->
                <div class="no-file-uploaded mt-20">
          <i  class="pi pi-file"></i>
          <span>No file uploaded</span>
        </div>
      </ng-template>
      <div *ngIf="staffProfileUploadError" class="text-danger small mt-2">{{ staffProfileUploadError }}</div>
      <p class="filesformat mb-0 mt-3">Supported formats: PDF, JPG, JPEG, PNG.<br />Maximum size: 15 MB.</p>
      <div class="row mb-3 mt-3">
        <div class="col-md-6">
          <label class="form-label fw-bold">Category<span class="text-danger">*</span></label>
          <ng-container *ngIf="staffUploadCategoryDisabled; else staffUploadCategoryDropdown">
            <input type="text" class="form-control" [value]="nameChangeUploadCategoryLabel" disabled />
          </ng-container>
          <ng-template #staffUploadCategoryDropdown>
            <p-dropdown
              [options]="activeUploadCategoryOptions"
              name="nameChangeUploadCategory"
              [(ngModel)]="nameChangeUploadCategoryKey"
              optionLabel="value"
              optionValue="key"
              [placeholder]="'Select Category'"
              [disabled]="staffProfileUploading"
              [filter]="true"
              filterBy="value"
              filterMatchMode="contains"
              styleClass="custom-req-dropdown"
              (onChange)="onUploadCategorySelect($event.value)">
            </p-dropdown>
          </ng-template>
          <div *ngIf="activeUploadCategoryOptions.length === 0" class="text-warning small mt-1">
            Loading categories…
          </div>
        </div>
        <div class="col-md-6">
          <label class="form-label fw-bold custom-req-label">Type<span class="text-danger">*</span></label>
          <!-- <select
            class="form-control"
            name="nameChangeUploadType"
            [(ngModel)]="nameChangeUploadTypeKey"
            [disabled]="staffProfileUploading"
            [matTooltip]="getSelectLabel(nameChangeUploadTypeKey, nameChangeUploadTypeOptions)"
            matTooltipPosition="above"
            matTooltipClass="custom-tooltip">
            <option value="">{{ placeholderMessage['P0030'] || 'Select Type' }}</option>
            <option *ngFor="let dt of nameChangeUploadTypeOptions" [value]="dt.key">{{ dt.value }}</option>
          </select> -->
          <p-dropdown #uploadTypeDropdown [options]="nameChangeUploadTypeOptions" name="nameChangeUploadType" [(ngModel)]="nameChangeUploadTypeKey"
            optionLabel="value" optionValue="key" [placeholder]="placeholderMessage['P0030'] || 'Select Type'"
            [disabled]="staffProfileUploading" [filter]="true" filterBy="value" filterMatchMode="contains"
            appendTo="body" [baseZIndex]="1100" panelStyleClass="lookup-upload-type-panel"
            (onShow)="onUploadTypeDropdownShow(uploadTypeDropdown)"
            styleClass="custom-req-dropdown">
          </p-dropdown>
        </div>
      </div>
      <!-- Notes not needed for name-change supporting upload; payload still sends empty notes from TS. -->
      <!--
      <div class="form-group mb-0 mt-3">
        <label class="font-weight-bold d-block" for="lookupStaffUploadNotes">Notes <span class="text-muted font-weight-normal">(optional)</span></label>
        <textarea
          id="lookupStaffUploadNotes"
          class="form-control"
          rows="2"
          [(ngModel)]="staffProfileUploadNotes"
          [disabled]="staffProfileUploading"
          maxlength="2000"
          placeholder="Optional notes for this document"></textarea>
      </div>
      -->
      <!-- <div *ngIf="staffProfileUploadError" class="text-danger small mt-2">{{ staffProfileUploadError }}</div> -->
    </div>
  </div>
  <div class="modal-footer  lookup-staff-modal-footer d-flex gap-2">
    <button type="button" class="btn btn-outline-primary" (click)="showCancelUploadConfirmation()" [disabled]="staffProfileUploading">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="onStaffProfileUploadSave()"
      [disabled]="staffProfileUploading || !nameChangeUploadCategoryKey || !nameChangeUploadTypeKey">
      <span *ngIf="staffProfileUploading">Saving…</span>
      <span *ngIf="!staffProfileUploading">Save</span>
    </button>
  </div>
</ng-template>

<ng-template #editPriorNameModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="lookup-edit-prior-title">Edit Record</h4>
    <button type="button" class="close activities-modal-dismiss" aria-labelledby="lookup-edit-prior-title" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div
      *ngIf="shouldShowEditPriorNameG0067Info()"
      class="alert alert-info small mb-3"
      role="status"
      aria-live="polite"
      id="lookup_edit_prior_info_g0067">
      {{ informationMessage['G0067'] || 'This prior name combination is already listed for this person.' }}
    </div>
    <form [formGroup]="addPriorNameForm" novalidate>
      <div class="row mb-3 formio-component formio-component-htmlelement formio-component-content">
        <p class="formio-component-htmlelement blue-bg app-para m-0">Only provide the previous names that appear on your official records (transcripts, test scores, etc.). If any documents are under a prior name, upload the legal name-change documentation (marriage certificate, divorce decree, court order, etc.).</p>
      </div>
      <div class="row mb-3">
        <div class="col-md-3">
          <label class="form-label fw-bold" for="lookup_prior_edit_first">First Name<span class="text-danger">*</span></label>
          <input id="lookup_prior_edit_first" type="text" class="form-control" formControlName="priorFirst" [placeholder]="placeholderMessage['P0001'] || 'Enter'"
            maxlength="30" minlength="2" autocomplete="given-name"
            [attr.aria-invalid]="addPriorNameForm.get('priorFirst')?.touched && addPriorNameForm.get('priorFirst')?.invalid ? 'true' : null"
            [ngClass]="{ 'is-invalid': addPriorNameForm.get('priorFirst')?.invalid && addPriorNameForm.get('priorFirst')?.touched }" />
          <div *ngIf="addPriorNameForm.get('priorFirst')?.touched && addPriorNameForm.get('priorFirst')?.errors as errors">
            <div *ngIf="errors['required']" class="text-danger small mt-1">{{ errorMessage['M0001'] || 'Required' }}</div>
            <div *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])" class="text-danger small mt-1">{{ errorMessage['M0002'] || 'Invalid format or length.' }}</div>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-bold" for="lookup_prior_edit_middle">Middle Name</label>
          <input id="lookup_prior_edit_middle" type="text" class="form-control" formControlName="priorMiddle" [placeholder]="placeholderMessage['P0002'] || 'Enter'"
            maxlength="30" autocomplete="additional-name"
            [ngClass]="{ 'is-invalid': addPriorNameForm.get('priorMiddle')?.invalid && addPriorNameForm.get('priorMiddle')?.touched }" />
          <div *ngIf="addPriorNameForm.get('priorMiddle')?.touched && addPriorNameForm.get('priorMiddle')?.errors as errors">
            <div *ngIf="errors['pattern'] || errors['maxlength']" class="text-danger small mt-1">{{ errorMessage['M0003'] || 'Invalid format or length.' }}</div>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-bold" for="lookup_prior_edit_last">Last Name<span class="text-danger">*</span></label>
          <input id="lookup_prior_edit_last" type="text" class="form-control" formControlName="priorLast" [placeholder]="placeholderMessage['P0003'] || 'Enter'"
            maxlength="30" minlength="2" autocomplete="family-name"
            [ngClass]="{ 'is-invalid': addPriorNameForm.get('priorLast')?.invalid && addPriorNameForm.get('priorLast')?.touched }" />
          <div *ngIf="addPriorNameForm.get('priorLast')?.touched && addPriorNameForm.get('priorLast')?.errors as errors">
            <div *ngIf="errors['required']" class="text-danger small mt-1">{{ errorMessage['M0004'] || 'Required' }}</div>
            <div *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])" class="text-danger small mt-1">{{ errorMessage['M0005'] || 'Invalid format or length.' }}</div>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-bold" for="lookup_prior_edit_suffix">Suffix</label>
          <div class="dropdown-clear-wrapper lookup-name-suffix-select">
            <select id="lookup_prior_edit_suffix" class="form-control" formControlName="priorSuffix"
              (change)="blurSelect($event)"
              [style.color]="addPriorNameForm.get('priorSuffix')?.value == null ? '#757575' : null"
              [ngClass]="{ 'empty-select': addPriorNameForm.get('priorSuffix')?.value == null }"
              [matTooltip]="getSelectLabel(addPriorNameForm.get('priorSuffix')?.value, suffixList)"
              matTooltipPosition="above"
              matTooltipClass="custom-tooltip">
              <option [ngValue]="null">{{ placeholderMessage['P0027'] || 'Select Suffix' }}</option>
              <option *ngFor="let s of suffixList" [ngValue]="s.key" [attr.aria-label]="getSuffixAriaLabel(s.value)">{{ s.value }}</option>
            </select>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer border-top d-flex gap-2">
    <button type="button" class="btn-cancel btn btn-primary btn-lg py-2 px-4" (click)="onResetEditPriorNameForm()">Reset</button>
    <button type="button" class="btn btn-primary btn-lg btnprimary" [disabled]="addPriorNameForm.invalid" (click)="onUpdatePriorNameFromModal(modal)">Update</button>
  </div>
</ng-template>
